/**
 * Legal content data — structured oferta and privacy policy sections.
 * Content in Uzbek (official legal language) and English.
 */

export interface LegalSection {
  readonly id: string
  readonly title: string
  readonly paragraphs: readonly string[]
}

export interface LegalDocument {
  readonly title: string
  readonly subtitle: string
  readonly effectiveDate: string
  readonly preamble: string
  readonly sections: readonly LegalSection[]
  readonly requisites: readonly string[]
}

// ─── OFERTA (O'zbek) ─────────────────────────────────────────

export const TERMS_UZ: LegalDocument = {
  title: 'Ommaviy oferta',
  subtitle: 'Dasturiy ta\'minotdan foydalanish xizmatlari bo\'yicha',
  effectiveDate: '2026-yil 25-mart',
  preamble:
    'Mazkur ommaviy oferta O\'zbekiston Respublikasi Fuqarolik Kodeksining 369-370-moddalariga muvofiq tuzilgan bo\'lib, Yakka tartibdagi tadbirkor Seitmuradov Muhammad Said Qilichovich (keyingi o\'rinlarda — «Ijrochi») tomonidan istalgan jismoniy yoki yuridik shaxsga (keyingi o\'rinlarda — «Foydalanuvchi») «Turnifly» platformasidan foydalanish xizmatlari ko\'rsatish shartlarini belgilaydi.',
  sections: [
    {
      id: 'terms',
      title: 'I. Atamalar va ta\'riflar',
      paragraphs: [
        'Platforma — «Turnifly» nomi ostida ishlaydigan dasturiy ta\'minot mahsuloti, shu jumladan Telegram Mini App (t.me/TurniflyBot), veb-sayt (turnifly.com), hamda kelajakda ishlab chiqiladigan mobil ilovalar.',
        'Ijrochi — YaTT Seitmuradov Muhammad Said Qilichovich (STIR: 596973238), Platformani ishlab chiquvchi va xizmat ko\'rsatuvchi.',
        'Foydalanuvchi — Platformada ro\'yxatdan o\'tgan va ushbu Oferta shartlarini qabul qilgan 14 yoshdan oshgan jismoniy shaxs.',
        'Obuna — Foydalanuvchiga Platformaning pullik funksiyalaridan ma\'lum muddat davomida foydalanish imkonini beruvchi xizmat. Obuna turlari: Premium, Expert, Company.',
        'Karta tokeni — To\'lov operatori tomonidan Foydalanuvchining bank kartasi ma\'lumotlari asosida yaratiladigan xavfsiz identifikator. Ijrochi bank karta raqamlarini saqlamaydi.',
        'Aksept — Foydalanuvchining ushbu Oferta shartlarini to\'liq va so\'zsiz qabul qilishi. Platformada ro\'yxatdan o\'tish, to\'lov amalga oshirish yoki Platformadan foydalanishni boshlash orqali amalga oshiriladi.',
      ],
    },
    {
      id: 'general',
      title: 'II. Umumiy qoidalar',
      paragraphs: [
        'Ushbu Oferta O\'zbekiston Respublikasining Fuqarolik Kodeksi, «Elektron tijorat to\'g\'risida»gi Qonuni (O\'RQ-385), «Iste\'molchilar huquqlarini himoya qilish to\'g\'risida»gi Qonuni (O\'RQ-662) va «Shaxsiy ma\'lumotlar to\'g\'risida»gi Qonuni (O\'RQ-547) asosida tuzilgan.',
        'Platformada ro\'yxatdan o\'tish, to\'lov amalga oshirish yoki Platformadan foydalanishni boshlash Foydalanuvchi tomonidan ushbu Oferta shartlarini to\'liq va so\'zsiz qabul qilganligini bildiradi (FK 370-moddasi).',
        'Ijrochi ushbu Ofertaga istalgan vaqtda o\'zgartirish kiritish huquqini o\'zida saqlaydi. O\'zgartirishlar Platformada e\'lon qilingan paytdan boshlab 10 kalendar kun o\'tgach kuchga kiradi.',
        'Agar Foydalanuvchi o\'zgartirilgan shartlarga rozi bo\'lmasa, u Platformadan foydalanishni to\'xtatishi va akkauntini o\'chirishi shart.',
      ],
    },
    {
      id: 'subject',
      title: 'III. Oferta predmeti',
      paragraphs: [
        'Ijrochi Foydalanuvchiga «Turnifly» platformasidan foydalanish xizmatlarini ko\'rsatadi. Platforma quyidagi xizmatlarni taqdim etadi:',
        '• Odatlarni yaratish, kuzatish va boshqarish (habit tracking)\n• Kunlik vazifalar jadvali (task boards)\n• Maqsadlar qo\'yish va kuzatish (goals)\n• Challengelar (shaxsiy, jamoaviy, pullik va bepul)\n• Ijtimoiy tarmoq funksiyalari (feed, izoh, layk, repost)\n• Bildirishnomalar va xabarlar (notifications, DM)\n• Hayot taymlayn va umr hisoblagichi\n• Gamifikatsiya tizimi (bog\'/gulzor, yutuqlar, ball)\n• Pomodoro taymer\n• Ekspert va kompaniya verifikatsiyasi',
        'Xizmatlarning ba\'zilari faqat pullik obuna (Premium, Expert, Company) egalariga taqdim etiladi.',
      ],
    },
    {
      id: 'registration',
      title: 'IV. Ro\'yxatdan o\'tish va akkaunt',
      paragraphs: [
        'Ro\'yxatdan o\'tish @TurniflyBot Telegram boti orqali amalga oshiriladi: til tanlash, telefon kontaktini ulashish va profil ma\'lumotlarini to\'ldirish.',
        'Foydalanuvchi ism-familiya (majburiy), telefon raqami, jinsi (majburiy — gamifikatsiya uchun) va Telegram ma\'lumotlarini taqdim etadi.',
        'Har bir Foydalanuvchi faqat bitta akkauntga ega bo\'lishi mumkin. Bir nechta akkaunt yaratish ta\'qiqlanadi.',
        'Foydalanuvchi istalgan vaqtda akkauntini o\'chirish huquqiga ega. O\'chirilgandan keyin 30 kun davomida ma\'lumotlar saqlanadi (qayta tiklash uchun), so\'ngra butunlay o\'chiriladi.',
      ],
    },
    {
      id: 'plans',
      title: 'V. Xizmat turlari va tariflar',
      paragraphs: [
        'Bepul tarif: maksimum 5 ta odat, 1 ta vazifalar jadvali, 1 ta bepul challengeda qatnashish. Maqsadlar, hayot taymlayn, DM va challenge yaratish mavjud emas.',
        'Premium obuna: cheksiz odatlar, cheksiz jadvallar, maqsadlar, hayot taymlayn, DM, shaxsiy challenge yaratish. Narxlar: 15 000 UZS/oy yoki 99 000 UZS/yil.',
        'Expert obuna: Premium + ommaviy challengelar yaratish, ko\'k tasdiq belgisi, pullik challengelardan daromad (25% komissiya). Narxlar: 49 999 UZS/oy yoki 499 999 UZS/yil.',
        'Company obuna: Expert + oltin tasdiq belgisi, musobaqalar tashkil etish, reklama bannerlari. Narxlar: 99 000 UZS/oy yoki 990 000 UZS/yil.',
        'Ijrochi narxlarni o\'zgartirish huquqini saqlaydi. O\'zgarish haqida kamida 10 kun oldin xabar beriladi. Joriy davrdagi narx o\'zgarmaydi.',
      ],
    },
    {
      id: 'payment',
      title: 'VI. To\'lov shartlari',
      paragraphs: [
        'To\'lovlar Payme va Click to\'lov tizimlari orqali amalga oshiriladi. Barcha narxlar O\'zbekiston so\'mida (UZS) ko\'rsatiladi.',
        'To\'lov muvaffaqiyatli amalga oshirilgandan so\'ng obuna darhol faollashtiriladi va belgilangan muddat (1 oy yoki 1 yil) davom etadi.',
        'Har bir muvaffaqiyatli to\'lov uchun elektron fiskal chek taqdim etiladi.',
      ],
    },
    {
      id: 'card-token',
      title: 'VII. Karta tokenizatsiyasi va avtomatik to\'lovlar',
      paragraphs: [
        'Foydalanuvchi bank kartasini Platformaga bog\'lashi mumkin. Karta ma\'lumotlari to\'lov operatori (Payme) tomonidan xavfsiz saqlanadi. Ijrochi bank karta raqamlarini, CVV kodlarini o\'z serverlarida SAQLAMAYDI.',
        'Karta bog\'lash: karta raqami kiritiladi → SMS tasdiqlash kodi keladi → kod kiritiladi → xavfsiz token yaratiladi.',
        'Kartani bog\'lash orqali Foydalanuvchi rozilik bildiradi: obuna tugaganda avtomatik to\'lov amalga oshiriladi, miqdor joriy narxga teng bo\'ladi, to\'lov obuna tugashidan 1 kun oldin yoki tugagan kuni bo\'ladi.',
        'Avtomatik to\'lov haqida kamida 3 kun oldin bildirishnoma yuboriladi.',
        'Muvaffaqiyatsiz to\'lov: 1-2 urinish — xizmatlar davom etadi; 3-urinish — imtiyozli muddat; 4+ urinish — obuna bekor, bepul tarifga o\'tkaziladi.',
        'Foydalanuvchi istalgan vaqtda kartani o\'chirishi, avtomatik to\'lovni bekor qilishi yoki boshqa kartaga almashitirishi mumkin.',
      ],
    },
    {
      id: 'gift',
      title: 'VIII. Sovg\'a obuna va promo kodlar',
      paragraphs: [
        'Boshqa shaxsga sovg\'a sifatida Premium obuna sotib olish mumkin. Sovg\'a uchun noyob promo kod (GIFT-XXXXXXXX) yaratiladi, amal qilish muddati 90 kun.',
        'Referral promo kodlari (TURNI-XXXXX) faqat birinchi marta obuna sotib olayotgan va ilgari referral chegirmasidan foydalanmagan Foydalanuvchilar uchun amal qiladi.',
      ],
    },
    {
      id: 'referral',
      title: 'IX. Referral (tavsiya) dasturi',
      paragraphs: [
        'Har bir Foydalanuvchiga shaxsiy referral kodi (TURNI-XXXXX) avtomatik beriladi.',
        'Tavsiya qilingan yangi Foydalanuvchi birinchi obuna sotib olganida, tavsiya qiluvchiga 2 000 UZS bonus, tavsiya qilingan Foydalanuvchiga 10% chegirma.',
        'Referral balans obuna to\'lovlarida ishlatilishi mumkin. Pul yechib olish: minimal 100 000 UZS, faqat Premium egalari uchun, 5 ish kuni ichida bank kartasiga o\'tkaziladi.',
      ],
    },
    {
      id: 'user-rights',
      title: 'X. Foydalanuvchining huquq va majburiyatlari',
      paragraphs: [
        'Huquqlari: Platformadan foydalanish, obuna turini tanlash, akkauntni o\'chirish, shaxsiy ma\'lumotlarni tahrirlash, kartani o\'chirish, da\'vo tartibida murojaat qilish.',
        'Majburiyatlari: to\'g\'ri ma\'lumot taqdim etish, akkaunt xavfsizligini ta\'minlash, Oferta va qonunchilikka rioya qilish.',
        'Taqiqlanadi: boshqalarni haqoratlash, noqonuniy kontent joylashtirish, virus tarqatish, tizimga ruxsatsiz kirish, soxta akkauntlar yaratish, spam tarqatish, boshqalarning ma\'lumotlarini to\'plash, firibgarlik.',
      ],
    },
    {
      id: 'provider-rights',
      title: 'XI. Ijrochining huquq va majburiyatlari',
      paragraphs: [
        'Huquqlari: funksionallikni o\'zgartirish, texnik ishlar uchun to\'xtatish, qoidabuzar akkauntlarni bloklash, narxlarni o\'zgartirish, kontent moderatsiyasi.',
        'Majburiyatlari: xizmatlarni Ofertaga muvofiq ko\'rsatish, Platformaning barqaror ishlashini ta\'minlash, shaxsiy ma\'lumotlarni himoya qilish, nosozliklarni bartaraf etish, murojaatlarga 5 ish kuni ichida javob berish.',
      ],
    },
    {
      id: 'challenges',
      title: 'XII. Challengelar va ekspert kontenti',
      paragraphs: [
        'Expert va Company obuna egalari pullik challengelar yaratishi mumkin (10 000 UZS dan 1 000 000 UZS gacha).',
        'Ijrochi pullik challengelardan 25% komissiya ushlab qoladi, qolgan 75% yaratuvchiga to\'lanadi.',
        'Challengeda qatnashish uchun to\'langan mablag\' qaytarilmaydi. Musobaqa sovrinlari yaratuvchi tomonidan ta\'minlanadi.',
      ],
    },
    {
      id: 'disclaimer',
      title: 'XIII. Muhim ogohlantirish (disclaimer)',
      paragraphs: [
        'PLATFORMA TIBBIY, SPORT, PSIXOLOGIK YOKI BOSHQA PROFESSIONAL MASLAHAT XIZMATI EMAS. Platforma faqat odatlarni kuzatish uchun texnik vosita (dasturiy ta\'minot) hisoblanadi.',
        'Ijrochi Foydalanuvchining odatlari (yugurish, sport, suv ichish, parhez, dori qabul qilish va boshqalar) natijasida yuzaga kelgan har qanday jarohat, kasallik, sog\'liq muammosi, ruhiy holat o\'zgarishi yoki o\'lim uchun JAVOBGAR EMAS.',
        'Challengelarda qatnashish ixtiyoriy. Foydalanuvchi ularda qatnashishdan oldin o\'z sog\'liq holatini mustaqil baholashi shart. Jismoniy shikast yoki zarar uchun Ijrochi javobgar emas.',
        'Foydalanuvchi o\'z odatlari va challengelari bilan bog\'liq BARCHA XAVF-XATARLARNI O\'Z ZIMMASIGA OLADI.',
        'Agar Foydalanuvchi odatni bajarmagan yoki challenge shartlarini uddalamagan bo\'lsa va stress, tashvish yoki ruhiy tushkunlik yuzaga kelsa — Ijrochi javobgar emas. Tegishli mutaxassisga murojaat tavsiya etiladi.',
        'Gamifikatsiya elementlari (ball, streak, jarima matnlari) faqat motivatsiya maqsadida ishlatiladi — majburlov yoki bosim vositasi emas.',
        'Uchinchi shaxslar (challenge yaratuvchilari, ekspertlar) tomonidan taqdim etilgan kontent uchun Ijrochi javobgar emas.',
      ],
    },
    {
      id: 'liability',
      title: 'XIV. Umumiy javobgarlik',
      paragraphs: [
        'Ijrochi javobgar bo\'lmaydi: akkauntga ruxsatsiz kirish (Foydalanuvchi xatosi), internet sifati, Telegram/to\'lov operatorlari uzilishlari, Foydalanuvchi kontenti, fors-major, odatlar/challengelar natijasida yuzaga kelgan jismoniy zarar, sog\'liq muammolari.',
        'Ijrochining umumiy javobgarligi Foydalanuvchi tomonidan oxirgi 3 oy ichida to\'langan obuna miqdoridan oshmaydi.',
        'Foydalanuvchi javobgar: Oferta buzilishi, qonunchilik buzilishi, uchinchi shaxslar huquqlari buzilishi, sog\'liq holatini hisobga olmagan holda odat/challenge bajarishi oqibatlari.',
      ],
    },
    {
      id: 'restriction',
      title: 'XV. Xizmatni cheklash va to\'xtatish',
      paragraphs: [
        'Ogohlantirish tizimi: 1-buzilish — ogohlantirish; 2-buzilish — ogohlantirish; 3-buzilish (30 kun ichida) — 7 kunlik bloklash (avtomatik); og\'ir buzilishlar — doimiy bloklash.',
        'Bloklangan Foydalanuvchining obuna mablag\'lari qaytarilmaydi.',
      ],
    },
    {
      id: 'refund',
      title: 'XVI. Pulni qaytarish siyosati',
      paragraphs: [
        'Platforma raqamli xizmatlar taqdim etadi. O\'zbekiston Respublikasining «Iste\'molchilar huquqlarini himoya qilish to\'g\'risida»gi Qonunining 23-moddasiga muvofiq, raqamli xizmatdan foydalanish boshlangandan so\'ng to\'lov qaytarilmaydi.',
        'Foydalanuvchi obunani istalgan vaqtda bekor qilishi mumkin — joriy davr oxirigacha xizmatlar davom etadi.',
        'Istisno: texnik xato tufayli ikki marta yechib olingan to\'lov — 10 ish kuni ichida qaytariladi; obuna faollashtirilmagan va 24 soat ichida murojaat qilingan.',
        'Murojaat: support@turnifly.com',
      ],
    },
    {
      id: 'ip',
      title: 'XVII. Intellektual mulk',
      paragraphs: [
        '«Turnifly» platformasi, uning dizayni, dasturiy kodi, logotipi va grafik elementlari Ijrochining mulki hisoblanadi.',
        'Foydalanuvchi kontentni joylashtirish orqali Ijrochiga ushbu kontentni Platforma doirasida ko\'rsatish, saqlash va tarqatish uchun litsenziya beradi.',
      ],
    },
    {
      id: 'force-majeure',
      title: 'XVIII. Fors-major holatlari',
      paragraphs: [
        'Tomonlar fors-major (tabiiy ofatlar, urush, davlat qarorlari, pandemiya, internet uzilishi, Telegram global uzilishi, kiberhujumlar) tufayli javobgar bo\'lmaydi.',
        'Fors-major 90 kundan ortiq davom etsa, har bir Tomon shartnomani bekor qilish huquqiga ega.',
      ],
    },
    {
      id: 'disputes',
      title: 'XIX. Nizolarni hal qilish',
      paragraphs: [
        'Nizolar muzokaralar yo\'li bilan hal qilinadi. Da\'vo support@turnifly.com ga yo\'naltiriladi, Ijrochi 15 kalendar kun ichida javob beradi.',
        'Da\'vo tartibida hal qilinmagan nizolar O\'zbekiston Respublikasi sudlarida ko\'rib chiqiladi.',
      ],
    },
    {
      id: 'duration',
      title: 'XX. Ofertaning amal qilish muddati',
      paragraphs: [
        'Oferta Foydalanuvchi tomonidan qabul qilingan paytdan boshlab kuchga kiradi va majburiyatlar to\'liq bajarilguncha amal qiladi.',
        'O\'zgartirishlar e\'lon qilingan kundan 10 kalendar kun o\'tgach kuchga kiradi.',
      ],
    },
    {
      id: 'age',
      title: 'XXI. Yosh chegarasi',
      paragraphs: [
        'Platformadan foydalanish uchun Foydalanuvchi kamida 14 (o\'n to\'rt) yoshda bo\'lishi shart.',
        '14 yoshga to\'lmagan shaxslar Platformadan foydalanishi mumkin emas. Ijrochi ularning foydalanishi bilan bog\'liq javobgarlikni o\'z zimmasiga olmaydi.',
        '14 dan 18 yoshgacha bo\'lgan Foydalanuvchilar qonuniy vakillarining (ota-onalar, vasiylar) roziligi bilan foydalanishi kerak.',
      ],
    },
    {
      id: 'final',
      title: 'XXII. Yakuniy qoidalar',
      paragraphs: [
        'Ofertaning biror qoidasi amalda bo\'lmagan deb topilsa, qolgan qoidalar o\'z kuchini saqlaydi.',
        'Tomonlar munosabatlariga O\'zbekiston Respublikasi qonunchiligi amal qiladi.',
      ],
    },
  ],
  requisites: [
    'YaTT Seitmuradov Muhammad Said Qilichovich',
    'STIR (INN): 596973238',
    'Ro\'yxat raqami: 7607045 (18.03.2026)',
    'IFUT: 62.01.0',
    '',
    'Manzil: Buxoro viloyati, Olot tumani, Talqon-Sayyot, Ziyokor ko\'chasi, 4-uy.',
    '',
    'Bank: "Kapitalbank" ATB, Chorsu filiali',
    'Hisob raqam: 20218000107427311001',
    'MFO: 01158',
    '',
    'Email: support@turnifly.com',
    'Veb-sayt: turnifly.com',
    'Telegram: t.me/TurniflyBot',
    'Telegram kanal: t.me/Turnifly',
  ],
}

// ─── OFERTA (English) ────────────────────────────────────────

export const TERMS_EN: LegalDocument = {
  title: 'Public Offer',
  subtitle: 'Software service usage agreement',
  effectiveDate: 'March 25, 2026',
  preamble:
    'This public offer is drawn up in accordance with Articles 369–370 of the Civil Code of the Republic of Uzbekistan and defines the terms of service for the "Turnifly" platform provided by Individual Entrepreneur Seitmuradov Muhammad Said Kilichovich (hereinafter — "Provider") to any individual or legal entity (hereinafter — "User").',
  sections: [
    {
      id: 'terms',
      title: 'I. Terms and Definitions',
      paragraphs: [
        'Platform — software product "Turnifly", including Telegram Mini App (t.me/TurniflyBot), website (turnifly.com), and future mobile applications.',
        'Provider — IE Seitmuradov Muhammad Said Kilichovich (TIN: 596973238), developer and operator of the Platform.',
        'User — an individual aged 14 or older, registered on the Platform and who has accepted this Offer.',
        'Subscription — a service granting the User access to paid Platform features for a specified period. Types: Premium, Expert, Company.',
        'Card token — a secure identifier created by the Payment operator based on the User\'s bank card data. The Provider does not store bank card numbers.',
        'Acceptance — the User\'s full and unconditional acceptance of this Offer, carried out by registering, making a payment, or starting to use the Platform.',
      ],
    },
    {
      id: 'general',
      title: 'II. General Provisions',
      paragraphs: [
        'This Offer is based on the Civil Code, the Law "On Electronic Commerce" (ZRU-385), the Law "On Consumer Rights Protection" (ZRU-662), and the Law "On Personal Data" (ZRU-547).',
        'Registration, payment, or starting to use the Platform constitutes full acceptance of this Offer (Article 370 of the Civil Code).',
        'The Provider reserves the right to amend this Offer. Changes take effect 10 calendar days after publication on the Platform.',
        'If the User disagrees with amended terms, they must stop using the Platform and delete their account.',
      ],
    },
    {
      id: 'subject',
      title: 'III. Subject of the Offer',
      paragraphs: [
        'The Provider offers the following services through the "Turnifly" platform:',
        '• Habit tracking and management\n• Task boards\n• Goal setting and tracking\n• Challenges (personal, team, paid, free)\n• Social network features (feed, comments, likes, reposts)\n• Notifications and direct messages\n• Life timeline and life counter\n• Gamification system (garden/orchard, achievements, points)\n• Pomodoro timer\n• Expert and company verification',
        'Some services are available only to paid subscription holders (Premium, Expert, Company).',
      ],
    },
    {
      id: 'registration',
      title: 'IV. Registration and Account',
      paragraphs: [
        'Registration is done through the @TurniflyBot Telegram bot: language selection, sharing phone contact, and filling profile data.',
        'The User provides: name (required), phone number, gender (required — for gamification), and Telegram data (automatically transmitted).',
        'Each User may have only one account. Creating multiple accounts is prohibited.',
        'The User may delete their account at any time. Data is retained for 30 days (for recovery), then permanently deleted.',
      ],
    },
    {
      id: 'plans',
      title: 'V. Service Types and Plans',
      paragraphs: [
        'Free plan: max 5 habits, 1 task board, 1 free challenge participation. Goals, life timeline, DM, and challenge creation are unavailable.',
        'Premium: unlimited habits, task boards, goals, life timeline, DM, personal challenges. Prices: 15,000 UZS/month or 99,000 UZS/year.',
        'Expert: Premium + public challenges, blue verified badge, income from paid challenges (25% commission). Prices: 49,999 UZS/month or 499,999 UZS/year.',
        'Company: Expert + gold badge, competitions, ad banners. Prices: 99,000 UZS/month or 990,000 UZS/year.',
        'The Provider reserves the right to change prices with at least 10 days notice. Current period prices remain unchanged.',
      ],
    },
    {
      id: 'payment',
      title: 'VI. Payment Terms',
      paragraphs: [
        'Payments are made via Payme and Click payment systems. All prices are in Uzbek sum (UZS).',
        'After successful payment, the subscription is activated immediately and lasts for the paid period (1 month or 1 year).',
        'An electronic fiscal receipt is issued for each successful payment.',
      ],
    },
    {
      id: 'card-token',
      title: 'VII. Card Tokenization and Auto-Payments',
      paragraphs: [
        'The User may link a bank card to the Platform. Card data is stored securely by the Payment operator (Payme). The Provider does NOT store card numbers or CVV codes on its servers.',
        'Card linking process: enter card number → receive SMS verification code → enter code → secure token is created.',
        'By linking a card, the User agrees: automatic payment upon subscription expiry, amount equals current price, payment occurs 1 day before or on expiry date.',
        'Auto-payment notification is sent at least 3 days in advance.',
        'Failed payment: 1-2 attempts — services continue; 3rd attempt — grace period; 4+ attempts — subscription cancelled, account moved to free plan.',
        'The User may remove a linked card, cancel auto-payments, or switch to another card at any time.',
      ],
    },
    {
      id: 'gift',
      title: 'VIII. Gift Subscriptions and Promo Codes',
      paragraphs: [
        'Users may purchase Premium as a gift. A unique promo code (GIFT-XXXXXXXX) is created, valid for 90 days.',
        'Referral promo codes (TURNI-XXXXX) are valid only for first-time subscribers who haven\'t previously used a referral discount.',
      ],
    },
    {
      id: 'referral',
      title: 'IX. Referral Program',
      paragraphs: [
        'Each User receives a personal referral code (TURNI-XXXXX) automatically.',
        'When a referred User purchases their first subscription: referrer gets 2,000 UZS bonus, referred User gets 10% discount.',
        'Referral balance can be used for subscription payments. Withdrawal: minimum 100,000 UZS, Premium holders only, transferred to bank card within 5 business days.',
      ],
    },
    {
      id: 'user-rights',
      title: 'X. User Rights and Obligations',
      paragraphs: [
        'Rights: use the Platform, choose subscription type, delete account, edit personal data, remove linked card, file claims.',
        'Obligations: provide accurate data, ensure account security, comply with the Offer and legislation.',
        'Prohibited: insulting others, posting illegal content, distributing viruses, unauthorized system access, creating fake accounts, spam, collecting others\' data, fraud.',
      ],
    },
    {
      id: 'provider-rights',
      title: 'XI. Provider Rights and Obligations',
      paragraphs: [
        'Rights: modify functionality, suspend for maintenance, block violating accounts, change prices, moderate content.',
        'Obligations: provide services per the Offer, ensure Platform stability, protect personal data, fix issues, respond to inquiries within 5 business days.',
      ],
    },
    {
      id: 'challenges',
      title: 'XII. Challenges and Expert Content',
      paragraphs: [
        'Expert and Company subscribers may create paid challenges (10,000 to 1,000,000 UZS).',
        'The Provider retains a 25% commission on paid challenges; 75% goes to the creator.',
        'Challenge participation payments are non-refundable. Competition prizes are provided by the creator.',
      ],
    },
    {
      id: 'disclaimer',
      title: 'XIII. Important Disclaimer',
      paragraphs: [
        'THE PLATFORM IS NOT A MEDICAL, SPORTS, PSYCHOLOGICAL, OR OTHER PROFESSIONAL ADVISORY SERVICE. The Platform is solely a technical tool (software) for tracking and managing habits.',
        'The Provider is NOT LIABLE for any injuries, illnesses, health problems, changes in mental state, or death resulting from the User performing habits tracked on the Platform (including but not limited to: running, sports, water consumption, diet, medication, meditation, etc.).',
        'Challenge participation is voluntary. The User must independently assess their health condition before participating. The Provider is not liable for physical injury or harm.',
        'The User ASSUMES ALL RISKS associated with performing their habits, challenges, or goals.',
        'If the User fails to complete a habit or challenge and experiences stress, anxiety, or depression — the Provider is not liable. Consulting a relevant specialist is recommended.',
        'Gamification elements (points, streaks, penalty texts) are used solely for motivation — not as coercion or pressure.',
        'The Provider is not liable for content provided by third parties (challenge creators, experts).',
      ],
    },
    {
      id: 'liability',
      title: 'XIV. General Liability',
      paragraphs: [
        'The Provider is not liable for: unauthorized account access (User\'s fault), internet quality, Telegram/payment operator outages, User content, force majeure, physical harm or health issues arising from habits/challenges.',
        'The Provider\'s total liability shall not exceed the subscription amount paid by the User in the last 3 months.',
        'The User is liable for: violating the Offer, violating legislation, violating third-party rights, performing habits/challenges without regard to their health condition.',
      ],
    },
    {
      id: 'restriction',
      title: 'XV. Service Restriction and Termination',
      paragraphs: [
        'Warning system: 1st violation — warning; 2nd — warning; 3rd (within 30 days) — 7-day auto-block; severe violations — permanent block.',
        'Blocked User subscription funds are non-refundable.',
      ],
    },
    {
      id: 'refund',
      title: 'XVI. Refund Policy',
      paragraphs: [
        'The Platform provides digital services. Per Article 23 of the Consumer Rights Protection Law (ZRU-662), payments are non-refundable after digital service use begins.',
        'The User may cancel subscription at any time — services continue until the end of the current period.',
        'Exceptions: technical error causing double charge — refunded within 10 business days; subscription not activated and User contacts within 24 hours.',
        'Contact: support@turnifly.com',
      ],
    },
    {
      id: 'ip',
      title: 'XVII. Intellectual Property',
      paragraphs: [
        'The "Turnifly" platform, its design, code, logo, and graphic elements are the property of the Provider.',
        'By posting content, the User grants the Provider a license to display, store, and distribute such content within the Platform.',
      ],
    },
    {
      id: 'force-majeure',
      title: 'XVIII. Force Majeure',
      paragraphs: [
        'Parties are not liable for force majeure (natural disasters, war, government decisions, pandemics, internet outages, global Telegram outages, cyberattacks).',
        'If force majeure lasts over 90 days, either Party may terminate the agreement.',
      ],
    },
    {
      id: 'disputes',
      title: 'XIX. Dispute Resolution',
      paragraphs: [
        'Disputes are resolved through negotiation. Claims are sent to support@turnifly.com; the Provider responds within 15 calendar days.',
        'Unresolved disputes are handled by courts of the Republic of Uzbekistan.',
      ],
    },
    {
      id: 'duration',
      title: 'XX. Offer Validity',
      paragraphs: [
        'The Offer takes effect upon User acceptance and remains valid until all obligations are fulfilled.',
        'Amendments take effect 10 calendar days after publication.',
      ],
    },
    {
      id: 'age',
      title: 'XXI. Age Restriction',
      paragraphs: [
        'Users must be at least 14 years old to use the Platform.',
        'Persons under 14 may not use the Platform. The Provider bears no responsibility for their use.',
        'Users aged 14-18 must have consent from legal representatives (parents or guardians).',
      ],
    },
    {
      id: 'final',
      title: 'XXII. Final Provisions',
      paragraphs: [
        'If any provision is found invalid, the remaining provisions retain their force.',
        'The legislation of the Republic of Uzbekistan applies to all relations between the Parties.',
      ],
    },
  ],
  requisites: [
    'IE Seitmuradov Muhammad Said Kilichovich',
    'TIN (STIR): 596973238',
    'Registration #: 7607045 (03/18/2026)',
    'OKED: 62.01.0',
    '',
    'Address: Bukhara region, Olot district, Talkon-Sayyot, Ziyokor st., 4.',
    '',
    'Bank: Kapitalbank JSC, Chorsu branch',
    'Account: 20218000107427311001',
    'MFO: 01158',
    '',
    'Email: support@turnifly.com',
    'Website: turnifly.com',
    'Telegram: t.me/TurniflyBot',
    'Telegram channel: t.me/Turnifly',
  ],
}

// ─── PRIVACY POLICY (O'zbek) ────────────────────────────────

export const PRIVACY_UZ: LegalDocument = {
  title: 'Maxfiylik siyosati',
  subtitle: 'Shaxsiy ma\'lumotlarni to\'plash va qayta ishlash siyosati',
  effectiveDate: '2026-yil 25-mart',
  preamble:
    'Mazkur Maxfiylik siyosati YaTT Seitmuradov Muhammad Said Qilichovich (STIR: 596973238) tomonidan «Turnifly» platformasi foydalanuvchilarining shaxsiy ma\'lumotlarini to\'plash, qayta ishlash, saqlash va himoya qilish tartibini belgilaydi. O\'RQ-547 «Shaxsiy ma\'lumotlar to\'g\'risida»gi Qonun asosida ishlab chiqilgan.',
  sections: [
    {
      id: 'collected',
      title: 'I. To\'planadigan ma\'lumotlar',
      paragraphs: [
        'Foydalanuvchi taqdim etadi: ism-familiya, telefon raqami, jinsi (majburiy); tug\'ilgan sana, bio, kasb, qiziqishlar, mamlakat, profil rasmi, banner (ixtiyoriy).',
        'Telegram orqali avtomatik olinadi: Telegram ID, ism, username, profil rasmi, til sozlamalari.',
        'Faollik ma\'lumotlari: odatlar, maqsadlar, vazifalar, challengelar, postlar, izohlar, layklar, xabarlar, bildirishnoma sozlamalari, faollik xaritasi, yutuqlar.',
        'To\'lov ma\'lumotlari: to\'lov tarixi, obuna holati, kartaning oxirgi 4 raqami, karta brendi Ijrochi serverida saqlanadi. To\'liq karta raqami va CVV SAQLANMAYDI — faqat to\'lov operatorida (Payme).',
        'Texnik ma\'lumotlar: IP manzil, qurilma turi, platforma versiyasi, sessiya ma\'lumotlari.',
      ],
    },
    {
      id: 'purposes',
      title: 'II. Ma\'lumotlarni to\'plash maqsadlari',
      paragraphs: [
        'Xizmat ko\'rsatish — Platformaning asosiy funksiyalarini ta\'minlash.',
        'Autentifikatsiya va xavfsizlik — Foydalanuvchini aniqlash, ruxsatsiz kirishni oldini olish.',
        'To\'lovlarni qayta ishlash — obuna to\'lovlari, karta tokenizatsiyasi, avtomatik to\'lovlar.',
        'Bildirishnomalar — Telegram bot va Platforma ichida xizmatga oid xabarlar.',
        'Xizmatni yaxshilash — umumlashtirilgan (anonim) statistika tahlili.',
        'Qonuniy majburiyatlar — soliq hisoboti, fiskal cheklar.',
      ],
    },
    {
      id: 'legal-basis',
      title: 'III. Huquqiy asoslar',
      paragraphs: [
        'Foydalanuvchining roziligi — Platformada ro\'yxatdan o\'tish orqali beriladi (O\'RQ-547, 9-modda).',
        'Shartnoma ijrosi — Ommaviy oferta shartlarini bajarish uchun zarur.',
        'Qonuniy majburiyatlar — soliq, moliya qonunchilik talablari.',
        'Qonuniy manfaatlar — Platformaning xavfsizligi va barqaror ishlashi.',
      ],
    },
    {
      id: 'third-party',
      title: 'IV. Uchinchi shaxslarga uzatish',
      paragraphs: [
        'Payme — karta ma\'lumotlari, to\'lov miqdori (to\'lovlarni qayta ishlash uchun).',
        'Click — to\'lov miqdori (to\'lovlarni qayta ishlash uchun).',
        'Telegram — Telegram ID, bot xabarlari (autentifikatsiya, bildirishnomalar).',
        'Ijrochi shaxsiy ma\'lumotlarni reklama maqsadlarida uchinchi shaxslarga SOTMAYDI va BERMAYDI.',
        'Vakolatli davlat organlari qonuniy talabiga binoan ma\'lumotlar uzatilishi mumkin.',
      ],
    },
    {
      id: 'cross-border',
      title: 'V. Transchegaraviy uzatish',
      paragraphs: [
        'Platforma quyidagi xizmatlardan foydalanadi (O\'RQ-547, 28-modda):',
        '• Supabase (AQSh/Yevropa) — ma\'lumotlar bazasi, AES-256 shifrlash\n• Cloudflare R2 (global CDN) — media fayllar, shifrlash\n• Railway (AQSh) — bot va API, TLS/SSL\n• Vercel (global CDN) — frontend hosting, HTTPS',
        'Ro\'yxatdan o\'tish orqali Foydalanuvchi transchegaraviy uzatishga aniq rozilik beradi.',
        'Himoya choralari: TLS 1.2+ shifrlash, at-rest encryption, Row Level Security (RLS), xizmat ko\'rsatuvchilar bilan shartnomalar.',
      ],
    },
    {
      id: 'retention',
      title: 'VI. Saqlash muddatlari',
      paragraphs: [
        'Akkaunt ma\'lumotlari — akkaunt faol bo\'lgan muddat + o\'chirilgandan keyin 30 kun.',
        'To\'lov tarixi — O\'zbekiston soliq qonunchiligiga muvofiq 5 yil.',
        'Texnik loglar (IP, sessiya) — 90 kun.',
        'Qo\'llab-quvvatlash xabarlari — 1 yil.',
        'Akkaunt o\'chirilganda: 30 kun ichida qayta tiklash mumkin, keyin butunlay o\'chiriladi (to\'lov tarixi bundan mustasno).',
      ],
    },
    {
      id: 'user-rights',
      title: 'VII. Foydalanuvchi huquqlari',
      paragraphs: [
        'O\'RQ-547, 12-modda asosida Foydalanuvchi huquqlari:',
        '• Axborot olish — qanday ma\'lumotlar to\'planayotganini bilish\n• Kirish — o\'z ma\'lumotlari nusxasini so\'rash\n• Tuzatish — noto\'g\'ri ma\'lumotlarni tuzattirish\n• O\'chirish — ma\'lumotlarni o\'chirilishini talab qilish\n• Rozilikni qaytarib olish — istalgan vaqtda\n• Shikoyat — vakolatli organlarga murojaat',
        'Murojaat: support@turnifly.com yoki @TurniflyBot (qo\'llab-quvvatlash). Javob 10 ish kuni ichida.',
      ],
    },
    {
      id: 'security',
      title: 'VIII. Ma\'lumotlarni himoya qilish',
      paragraphs: [
        'Texnik choralar: TLS 1.2+ shifrlash, at-rest encryption, JWT autentifikatsiya, Row Level Security (RLS), rate limiting.',
        'To\'lov xavfsizligi: karta raqamlari Ijrochi serverida SAQLANMAYDI, tokenizatsiya Payme tomonidan amalga oshiriladi, PCI DSS standarti.',
        'Tashkiliy choralar: faqat vakolatli shaxslar kirish imkoniga ega, maxfiylik majburiyati, audit log.',
      ],
    },
    {
      id: 'children',
      title: 'IX. Bolalar ma\'lumotlari',
      paragraphs: [
        'Platforma 14 yoshga to\'lmagan shaxslarga mo\'ljallanmagan va ularning ma\'lumotlarini ataylab to\'plamaydi.',
        'Agar 14 yoshga to\'lmagan shaxs ma\'lumotlari aniqlansa, ular zudlik bilan o\'chiriladi.',
        '14-18 yoshdagilar qonuniy vakillarining roziligi bilan foydalanishi kerak.',
      ],
    },
    {
      id: 'cookies',
      title: 'X. Cookie va texnologiyalar',
      paragraphs: [
        'localStorage — autentifikatsiya tokenlari, til sozlamalari, foydalanuvchi afzalliklari uchun. Uchinchi shaxslarga uzatilmaydi.',
        'Platforma uchinchi tomon kuzatish (tracking) xizmatlari, reklama piksellarini yoki analitika skriptlarini ISHLATMAYDI.',
      ],
    },
    {
      id: 'breach',
      title: 'XI. Ma\'lumotlar buzilishi',
      paragraphs: [
        'Ruxsatsiz kirish, o\'chirish yoki tarqatish aniqlansa: sabablar tekshiriladi, 72 soat ichida ta\'sirlangan Foydalanuvchilar xabardor qilinadi, zarur hollarda vakolatli organlarga xabar beriladi.',
      ],
    },
    {
      id: 'changes',
      title: 'XII. O\'zgartirish kiritish',
      paragraphs: [
        'Ijrochi Siyosatni istalgan vaqtda yangilash huquqini saqlaydi. Muhim o\'zgarishlar haqida Telegram bot orqali xabar yuboriladi.',
        'Platformadan foydalanishni davom ettirish yangi shartlarni qabul qilganlik hisoblanadi.',
      ],
    },
  ],
  requisites: [
    'YaTT Seitmuradov Muhammad Said Qilichovich',
    'STIR: 596973238',
    'Manzil: Buxoro viloyati, Olot tumani, Talqon-Sayyot, Ziyokor ko\'chasi, 4-uy.',
    '',
    'Email: support@turnifly.com',
    'Telegram: t.me/TurniflyBot',
    'Telegram kanal: t.me/Turnifly',
  ],
}

// ─── PRIVACY POLICY (English) ───────────────────────────────

export const PRIVACY_EN: LegalDocument = {
  title: 'Privacy Policy',
  subtitle: 'Personal data collection and processing policy',
  effectiveDate: 'March 25, 2026',
  preamble:
    'This Privacy Policy defines the procedure for collecting, processing, storing, and protecting personal data of users of the "Turnifly" platform by IE Seitmuradov Muhammad Said Kilichovich (TIN: 596973238). Developed in accordance with the Law "On Personal Data" (ZRU-547).',
  sections: [
    {
      id: 'collected',
      title: 'I. Data Collected',
      paragraphs: [
        'User provides: name, phone number, gender (required); birth date, bio, profession, interests, country, avatar, banner (optional).',
        'From Telegram automatically: Telegram ID, name, username, profile photo, language settings.',
        'Activity data: habits, goals, tasks, challenges, posts, comments, likes, messages, notification settings, activity heatmap, achievements.',
        'Payment data: payment history, subscription status, last 4 card digits, card brand are stored on Provider\'s server. Full card number and CVV are NOT stored — only at the Payment operator (Payme).',
        'Technical data: IP address, device type, platform version, session data.',
      ],
    },
    {
      id: 'purposes',
      title: 'II. Purposes of Data Collection',
      paragraphs: [
        'Service provision — ensuring core Platform functionality.',
        'Authentication and security — User identification, preventing unauthorized access.',
        'Payment processing — subscription payments, card tokenization, auto-payments.',
        'Notifications — service-related messages via Telegram bot and Platform.',
        'Service improvement — analysis of aggregated (anonymous) statistics.',
        'Legal obligations — tax reporting, fiscal receipts.',
      ],
    },
    {
      id: 'legal-basis',
      title: 'III. Legal Basis',
      paragraphs: [
        'User consent — given through Platform registration (ZRU-547, Article 9).',
        'Contract performance — necessary to fulfill the Public Offer terms.',
        'Legal obligations — tax and financial legislation requirements.',
        'Legitimate interests — ensuring Platform security and stability.',
      ],
    },
    {
      id: 'third-party',
      title: 'IV. Third-Party Disclosure',
      paragraphs: [
        'Payme — card data, payment amounts (for payment processing).',
        'Click — payment amounts (for payment processing).',
        'Telegram — Telegram ID, bot messages (authentication, notifications).',
        'The Provider does NOT sell or share personal data with third parties for advertising purposes.',
        'Data may be disclosed upon lawful request from authorized government agencies.',
      ],
    },
    {
      id: 'cross-border',
      title: 'V. Cross-Border Transfer',
      paragraphs: [
        'The Platform uses the following services (ZRU-547, Article 28):',
        '• Supabase (USA/Europe) — database, AES-256 encryption\n• Cloudflare R2 (global CDN) — media files, encryption\n• Railway (USA) — bot and API, TLS/SSL\n• Vercel (global CDN) — frontend hosting, HTTPS',
        'By registering, the User gives explicit consent to cross-border data transfer.',
        'Protection measures: TLS 1.2+ encryption, at-rest encryption, Row Level Security (RLS), service provider agreements.',
      ],
    },
    {
      id: 'retention',
      title: 'VI. Data Retention',
      paragraphs: [
        'Account data — duration of active account + 30 days after deletion.',
        'Payment history — 5 years per Uzbekistan tax legislation.',
        'Technical logs (IP, session) — 90 days.',
        'Support messages — 1 year.',
        'Account deletion: recoverable within 30 days, then permanently deleted (except payment history).',
      ],
    },
    {
      id: 'user-rights',
      title: 'VII. User Rights',
      paragraphs: [
        'Under ZRU-547, Article 12:',
        '• Right to information — know what data is collected\n• Right to access — request a copy of your data\n• Right to correction — correct inaccurate data\n• Right to deletion — request data deletion\n• Right to withdraw consent — at any time\n• Right to complain — to authorized bodies',
        'Contact: support@turnifly.com or @TurniflyBot (support). Response within 10 business days.',
      ],
    },
    {
      id: 'security',
      title: 'VIII. Data Protection',
      paragraphs: [
        'Technical measures: TLS 1.2+ encryption, at-rest encryption, JWT authentication, Row Level Security (RLS), rate limiting.',
        'Payment security: card numbers NOT stored on Provider\'s servers, tokenization by Payme, PCI DSS standard.',
        'Organizational measures: access limited to authorized personnel only, confidentiality obligations, audit logging.',
      ],
    },
    {
      id: 'children',
      title: 'IX. Children\'s Data',
      paragraphs: [
        'The Platform is not intended for persons under 14 and does not intentionally collect their data.',
        'If data of a person under 14 is discovered, it will be immediately deleted.',
        'Users aged 14-18 must have consent from legal representatives (parents or guardians).',
      ],
    },
    {
      id: 'cookies',
      title: 'X. Cookies and Technologies',
      paragraphs: [
        'localStorage — for authentication tokens, language settings, user preferences. Not shared with third parties.',
        'The Platform does NOT use third-party tracking services, advertising pixels, or analytics scripts.',
      ],
    },
    {
      id: 'breach',
      title: 'XI. Data Breach',
      paragraphs: [
        'If unauthorized access, deletion, or distribution is detected: causes are investigated, affected Users are notified within 72 hours, authorized bodies are notified if necessary.',
      ],
    },
    {
      id: 'changes',
      title: 'XII. Policy Changes',
      paragraphs: [
        'The Provider reserves the right to update this Policy at any time. Significant changes are communicated via Telegram bot.',
        'Continued use of the Platform constitutes acceptance of new terms.',
      ],
    },
  ],
  requisites: [
    'IE Seitmuradov Muhammad Said Kilichovich',
    'TIN: 596973238',
    'Address: Bukhara region, Olot district, Talkon-Sayyot, Ziyokor st., 4.',
    '',
    'Email: support@turnifly.com',
    'Telegram: t.me/TurniflyBot',
    'Telegram channel: t.me/Turnifly',
  ],
}
